/* BEGIN Segmented Control helper */
(function($) {
    var Segmented_Control = {
        config: {

        },

        init: function( options ){
            let self = this;
            $.extend( this.config, options );

            $(document).ready(function() {
                self.initUI();
            });
        },

        initUI: function() {
            $('.segmented-control__item').bind('click', function() {
                $('.segmented-control__item').removeClass('active');
                $(this).addClass('active');
            });
        }
    }.init();
})(jQuery);
/* End Segmented Control helper */